module.exports = __webpack_public_path__ + "img/13.eed24069.jpg";